import { openDB } from 'idb';

let dbPromise = null;

// Opened on first use so that importing this module has no side effects (and works where
// IndexedDB is unavailable, e.g. in tests).
const getDb = () => {
  if (!dbPromise) {
    if (typeof indexedDB === 'undefined') {
      return Promise.reject(new Error('IndexedDB is not available'));
    }
    dbPromise = openDB('image-store', 1, {
      upgrade(db) {
        db.createObjectStore('images');
      },
    });
  }
  return dbPromise;
};

export async function getImage(name) {
  return (await getDb()).get('images', name);
}

export async function setImage(name, image) {
  return (await getDb()).put('images', image, name);
}

export async function deleteImage(name) {
  return (await getDb()).delete('images', name);
}

export async function getAllImages() {
  return (await getDb()).getAll('images');
}
